import globals from '../globals';
export default {
    data() {
        return {
            warning_msg:"",
        }
    },
    components: {
        globals
    },
    methods: {
        async getScmProducts(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.SCM_URL + "/products/get_product_by_id", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){

                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async ProductsList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.SCM_URL + "/products/get_all_products", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){

                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async TemplateList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.SCM_URL + "/sales_settings/list", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){

                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/productList.js